import React, { FC, createContext, useContext } from 'react';
import initStore from './initStore'
import { configure } from "mobx";

configure({
    isolateGlobalState: true
});

export const MyContext = createContext<typeof initStore>(initStore);

/**
 * 自定义使用store hooks
 * @param type 状态文件标识
 * @returns 
 * @example 
    import TestStore from '@/stores/TestStore';
    import {observer}  from 'mobx-react'
    const Page = () => {
        const testStore = useStore('TestStore') as typeof TestStore;
        return (
            <p onClick={()=>{testStore.changeTest('切换了')}}>{testStore.test}</p>
        )
    }
    export default observer(Page);
 */
export const useStore = (type: string = '') => {
    const store = useContext(MyContext);
    return store(type);
}

const MyProvider: FC = ({ children }) => {
    return (
        <MyContext.Provider value={initStore}>
            {children}
        </MyContext.Provider>
    );
}

export default MyProvider;